if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}
function attributeToString(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
}

function wait_for_elem(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// Close cart drawer function
function closeCartDrawer() {
  document.querySelector("#cartDrawer")?.classList.remove("opened");
  document.querySelector("#cartDrawerBackdrop")?.classList.remove("active");
}

// Open cart drawer function
function openCartDrawer() {
  document.querySelector("#cartDrawer")?.classList.add("opened");
  document.querySelector("#cartDrawerBackdrop")?.classList.add("active");
}

wait_for_elem(".jsDrawerClose").then((elem) => {
  elem.addEventListener("click", closeCartDrawer);
});

// Close cart when clicking backdrop
wait_for_elem("#cartDrawerBackdrop").then((elem) => {
  elem.addEventListener("click", closeCartDrawer);
});

const drawer_sample_names = ".drawerSamplesBox .drawerSamplesName label";

function toTitleCase(str) {
  return str
    .toLowerCase()
    .replace(/(?:^|\s)\w/g, function (match) {
      return match.toUpperCase();
    });
}

window.fixCartSampleNames = () => {
  wait_for_elem(drawer_sample_names).then((drawer_sample_name) => {
    let drawerSampleNames = document.querySelectorAll(drawer_sample_names);
  
    drawerSampleNames.forEach(function (title) {
      let originalTitle = title.getAttribute('data-title');
      let titleCaseTitle = toTitleCase(originalTitle).replace("By Far", "BY FAR");
  
      title.textContent = titleCaseTitle;
    });     
  });  
};

window.fixCartSampleNames();


function replaceCurrencySymbolCart(elem) {
  // Recursive function to walk through all text nodes
  function walk(node) {
    for (let i = 0; i < node.childNodes.length; i++) {
      const child = node.childNodes[i];
      if (child.nodeType === 3) {
        child.nodeValue = child.nodeValue.replace(/лв/g, "BGN");
      } else {
        walk(child);
      }
    }
  }

  walk(elem);
}

function setBGNInCart() {
  wait_for_elem("#cartDrawer").then((cartElem) => {
    replaceCurrencySymbolCart(cartElem);

    let currency_interval_counter = 0;

    const intervalEverySecond = setInterval(() => {
      replaceCurrencySymbolCart(cartElem);

      currency_interval_counter++;

      if (currency_interval_counter >= 10) {
        clearInterval(intervalEverySecond);
      }
    }, 1000);
  });
}

async function getCorrectPrice(productId, variantId) {
  let countryCode = window.Shopify.country || "DE"; // get country from cart or default to 'US'
  let response = await fetch("/api/2023-04/graphql", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "312c68c75076c4c6c48eb4eb2e159bae",
    },
    body: JSON.stringify({
      query: `query getProductById($id: ID!) @inContext(country: ${countryCode}) {
                            product(id: $id) {
                                variants(first: 100) {
                                    nodes{
                                        price {
                                          amount
                                          currencyCode
                                        }
                                        compareAtPrice {
                                          amount
                                          currencyCode
                                        }
                                        id
                                        title
                                    }
                                }
                            }
                        }`,
      variables: {
        id: `gid://shopify/Product/${productId}`,
      },
    }),
  });
  let json = await response.json();
  /*
  console.log("query")
  console.log(`query getProductById($id: ID!) @inContext(country: ${countryCode}) {
                            product(id: $id) {
                                variants(first: 100) {
                                    nodes{
                                        price {
                                          amount
                                          currencyCode
                                        }
                                        compareAtPrice {
                                          amount
                                          currencyCode
                                        }
                                        id
                                        title
                                    }
                                }
                            }
                        }`)
  console.log("variables")
  console.log({
        id: `gid://shopify/Product/${productId}`,
      })
  console.log("json received")
  console.log({productId, variantId})
  console.log(json)
  */
  let variants = json.data.product.variants.nodes;
  let variant = variants.find(
    (variant) => variant.id === `gid://shopify/ProductVariant/${variantId}`
  );
  if (!variant) {
    return undefined;
  }
  let result = {
    price: variant.price.amount,
    priceCurrencyCode: variant.price.currencyCode,
  };
  if (variant.compareAtPrice) {
    result.compareAtPrice = variant.compareAtPrice.amount;
    result.compareAtPriceCurrencyCode = variant.compareAtPrice.currencyCode;
  }
  return result;
}

ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};
ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + attributeToString(note),
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};
ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (!!data.message) {
    alert(data.message + "(" + data.status + "): " + data.description);
  }
};
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: jQuery(form).serialize(),
    dataType: "json",
    beforeSend: function () {
      $("body").addClass("velaCartAdding");
    },
    success: function (line_item) {
      $("body").removeClass("velaCartAdding");
      if (window.ajaxcart_type == "modal") {
        if (line_item.image != null) {
          $(".headerCartModal")
            .find(".cartProductImage img")
            .attr("src", line_item.image);
        } else {
          $(".headerCartModal")
            .find(".cartProductImage img")
            .attr("src", "//placehold.it/100x100");
        }
        $(".headerCartModal").find(".productTitle").html(line_item.title);
        $(".headerCartModal").addClass("active");
      }
      if (typeof callback === "function") {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.addItemFromCart = function (formData, callback, errorCallback) {
  var form = null;
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (typeof callback === "function") {
        callback(response, form);
      } else {
        ShopifyAPI.onItemAdded(response, form);
      }
    })
    .catch((error) => {
      if (typeof errorCallback === "function") {
        errorCallback(error);
      } else {
        alert(error);
      }
    });
};

ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON("/cart.js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  "use strict";
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $drawerCartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $drawerContainer;
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemAddedCallbackCart,
    itemErrorCallback,
    itemErrorCallbackCart,
    cartUpdateCallback,
    buildCart,
    updateSamples,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    createQtySelectors,
    qtySelectors,
    validateQty;
  init = function (options) {
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: "#cartContainer",
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      drawerCartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: window.money,
      disableAjaxCart: false,
      enableQtySelectors: true,
    };
    $.extend(settings, options);
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $drawerCartCountSelector = $(settings.drawerCartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $body = $("body");
    isUpdating = false;
    if (settings.enableQtySelectors) {
      qtySelectors();
    }
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }
    adjustCart();
  };
  loadCart = function () {
    $body.addClass("ajaxcartIsLoading");
    ShopifyAPI.getCart(cartUpdateCallback);
    setTimeout(() => openCartDrawer(), 250);
  };
  updateCountPrice = function (cart) {
    document
      .querySelectorAll(settings.cartCountSelector)
      .forEach(function (element) {
        element.innerHTML = cart.item_count;
        element.classList.remove("hidden-count");
        if (cart.item_count === 0) {
          element.classList.add("hidden-count");
          document
            .querySelector("span.byfar-icon-bag")
            .classList.remove("full");
          document.querySelector("span.byfar-icon-bag").classList.add("empty");
        } else {
          document
            .querySelector("span.byfar-icon-bag")
            .classList.remove("empty");
          document.querySelector("span.byfar-icon-bag").classList.add("full");
        }
      });

    document
      .querySelectorAll(settings.drawerCartCountSelector)
      .forEach(function (element) {
        element.innerText = cart.item_count;
      });

    if (cart.total_price) {
      document
        .querySelectorAll(settings.cartCostSelector)
        .forEach(function (element) {
          element.innerText = theme.Currency.formatMoney(
            cart.total_price,
            settings.moneyFormat
          );
        });
    }
    // if($drawerCartCountSelector) {
    //     $drawerCartCountSelector.text(cart.item_count);
    // }
    // if ($cartCostSelector) {
    //     $cartCostSelector.text(theme.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    // }
  };
  formOverride = function () {
    if (window.ajaxcart_type != "page") {
      $formContainer.on("submit", function (evt) {
        evt.preventDefault();
        $addToCart.removeClass("is-added").addClass("is-adding");
        $(".qtyError").remove();
        ShopifyAPI.addItemFromForm(
          evt.target,
          itemAddedCallback,
          itemErrorCallback
        );
        if ($formContainer.hasClass("formQuickview")) {
          $("#velaQuickView").fadeOut(500);
          $(".jsQuickview").html("");
          $(".jsQuickview").fadeOut(500);
        }
      });
    }
  };
  itemAddedCallback = function (product) {
    $addToCart.removeClass("is-adding").addClass("is-added");
    ShopifyAPI.getCart(cartUpdateCallback);
  };
  itemAddedCallbackCart = function (product) {
    $addToCart.removeClass("is-adding").addClass("is-added");
    ShopifyAPI.getCart(cartUpdateCallback);
  };
  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    $addToCart.removeClass("is-adding is-added");
    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after(
          '<div class="alert alert-danger qtyError">' +
            data.description +
            "</div>"
        );
      }
    }
  };
  itemErrorCallbackCart = function (error) {
    $addToCart.removeClass("is-adding is-added");
    if (!!error.statusText) {
      if (error.status == 422) {
        $formContainer.after(
          '<div class="alert alert-danger qtyError">' +
            error.statusText +
            "</div>"
        );
      }
    }
  };
  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);
    buildCart(cart);
  };
  updateSamples = function (cart) {
    var samplesAddedCount = 0;
    const SAMPLES_LIMIT = 1;
    const $stockingsSection = $(".drawerSamples.drawerStockings");
    const threshold = parseInt($stockingsSection.data("threshold")) || 50000; // Default 500 EUR in cents

    // Collect all stocking product IDs
    const stockingProductIds = [];
    $(".drawerSamplesGrid .drawerSamplesBox").each(function () {
      const productId = $(this).data("product-id");
      if (productId) {
        stockingProductIds.push(productId);
      }
    });

    // Reset all sample boxes
    $(".drawerSamplesGrid .drawerSamplesBox").removeClass("sample-added");
    $(".drawerSamplesGrid .drawerSamplesBox input[type='checkbox']").prop("checked", false).prop("disabled", false);

    // Check which stockings are already in cart (by product ID)
    $(".drawerSamplesGrid .drawerSamplesBox").each(function (index, item) {
      const $item = $(item);
      const productId = $item.data("product-id");

      $.each(cart.items, function (index, cartItem) {
        if (cartItem.product_id == productId) {
          // Check if the item is actually free
          const isFree = cartItem.final_price === 0;

          $item.addClass("sample-added");
          $item.data("selected-variant", cartItem.variant_id);
          var ch = $item.find('input[type="checkbox"]')[0];
          $(ch).prop("checked", true);
          samplesAddedCount++;

          // Mark the cart item appropriately
          $(".ajaxCartInner .drawerProduct").each(function (idx, drawerProduct) {
            var id = $(drawerProduct).data("id");
            if (id == cartItem.variant_id) {
              if (isFree) {
                $(drawerProduct).addClass("sample-item");
              } else {
                $(drawerProduct).removeClass("sample-item");
              }
              var sel = $(drawerProduct).find(".drawerQtySelect")[0];
              $(sel).prop("disabled", isFree);
            }
          });
        }
      });
    });

    // Show/hide stockings section based on cart threshold AND if limit not reached
    if (cart.total_price >= threshold && samplesAddedCount < SAMPLES_LIMIT) {
      $stockingsSection.show();
    } else {
      $stockingsSection.hide();
    }

    // Disable other sample checkboxes if limit reached
    if (samplesAddedCount >= SAMPLES_LIMIT) {
      $(".drawerSamplesGrid").addClass("max-samples-added");
    } else {
      $(".drawerSamplesGrid").removeClass("max-samples-added");
    }
  };
  buildCart = async function (cart) {
    $cartContainer.empty();
    if (window.ajaxcart_type == "modal") {
      if (cart.item_count === 0) {
        $cartContainer.append(
          '<div class="headerCartEmpty">' + window.cart_empty + "</div>"
        );
        cartCallback(cart);
        return;
      }
      var items = [],
        item = {},
        data = {};
      var source = $("#headerCartTemplate").html();
      // create function for comparing if two arguments are equal
      Handlebars.registerHelper("ifEquals", function (arg1, arg2) {
        return arg1 == arg2 ? true : false;
      });
      Handlebars.registerHelper("ifNotEquals", function (arg1, arg2, options) {
        if (arg1 != arg2) {
          return options.fn(this);
        }
        return options.inverse(this);
      });

      var template = Handlebars.compile(source);
      $.each(cart.items, function (index, cartItem) {
        if (cartItem.image != null) {
          var prodImg = cartItem.image
            .replace(/(\.[^.]*)$/, "_200x$1")
            .replace("http:", "");
        } else {
          var prodImg =
            "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }
        item = {
          id: cartItem.variant_id,
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: theme.Currency.formatMoney(
            cartItem.price,
            settings.moneyFormat
          ),
          vendor: cartItem.vendor,
        };
        items.push(item);
      });
      data = {
        items: items,
        note: cart.note,
        totalPrice: theme.Currency.formatMoney(
          cart.total_price,
          settings.moneyFormat
        ),
      };
      $cartContainer.append(template(data));
      cartCallback(cart);
    } else {
      if (cart.item_count === 0) {
        $cartContainer.append(
          '<div class="drawerCartEmpty">' + window.cart_empty + "</div>"
        );
        cartCallback(cart);
        return;
      }
      var items = [],
        item = {},
        data = {};
      var source = $("#CartTemplate").html();
      // create function for comparing if two arguments are equal
      Handlebars.registerHelper("ifEquals", function (arg1, arg2) {
        return arg1 == arg2 ? true : false;
      });
      Handlebars.registerHelper("ifNotEquals", function (arg1, arg2, options) {
        if (arg1 != arg2) {
          return options.fn(this);
        }
        return options.inverse(this);
      });
      Handlebars.registerHelper("isPublicProperty", function (key, options) {
        // Hide properties starting with underscore
        if (typeof key === 'string' && key.indexOf('_') === 0) {
          return options.inverse(this);
        }
        return options.fn(this);
      });
      // var template = Handlebars.compile(source);
      // let item_promises = [];
      // console.log(cart);
      // $.each(cart.items, function(index, cartItem) {
      //     item_promises.push(getCorrectPrice(cartItem.product_id, cartItem.variant_id).then((data) => {
      //         console.log(data);
      //         if (cartItem.image != null){
      //             var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
      //         } else {
      //             var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      //         }
      //         var price = data ? data.price.replace(".0","") + ' ' + data.currencyCode
      //                   : theme.Currency.formatMoney(cartItem.price, settings.moneyFormat);
      //         item = {
      //             id: cartItem.variant_id,
      //             line: index + 1, // Shopify uses a 1+ index in the API
      //             url: cartItem.url,
      //             img: prodImg,
      //             name: cartItem.product_title,
      //             variation: cartItem.variant_title,
      //             properties: cartItem.properties,
      //             itemAdd: cartItem.quantity + 1,
      //             itemMinus: cartItem.quantity - 1,
      //             itemQty: cartItem.quantity,
      //             price: price,
      //             vendor: cartItem.vendor
      //         };
      //         items.push(item);
      //     }));
      // });

      // await Promise.all(item_promises);

      // const formattedPrice = new Intl.NumberFormat('en', { style: 'currency', currency: cart.currency }).format(cart.total_price);
      // console.log(`${cart.total_price} ${formattedPrice}`)

      // data = {
      //     items: items,
      //     note: cart.note,
      //     totalPrice: `${cart.total_price / 100} ${cart.currency}`
      // }
      // $cartContainer.append(template(data));
      // cartCallback(cart);
      let item_promises = [];
      var template = Handlebars.compile(source);
      $.each(cart.items, function (index, cartItem) {
        item_promises.push(
          getCorrectPrice(cartItem.product_id, cartItem.variant_id).then(
            (data) => {
              if (cartItem.image != null) {
                var prodImg = cartItem.image
                  .replace(/(\.[^.]*)$/, "_200x$1")
                  .replace("http:", "");
              } else {
                var prodImg =
                  "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
              }
              item = {
                id: cartItem.variant_id,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: theme.Currency.formatMoney(
                  data.price * 100,
                  settings.moneyFormat
                ),
                vendor: cartItem.vendor,
              };
              let cart_item_extra_discount = false;
              try {
                cart_item_extra_discount =
                  cartItem.discounts[0].title === "EXTRA25";
              } catch (e) {}
              if (cart_item_extra_discount) {
                item["extra25"] = true;
              }
              if ("compareAtPrice" in data) {
                item["compareAtPrice"] = theme.Currency.formatMoney(
                  data.compareAtPrice * 100,
                  settings.moneyFormat
                );
              } else {
                if (cartItem.line_price < cartItem.original_line_price) {
                  item["compareAtPrice"] = theme.Currency.formatMoney(
                    cartItem.original_line_price,
                    settings.moneyFormat
                  );
                  item["price"] = theme.Currency.formatMoney(
                    cartItem.line_price,
                    settings.moneyFormat
                  );
                } else {
                  item["compareAtPrice"] = "";
                }
              }
              items.push(item);
            }
          )
        );
      });

      await Promise.all(item_promises);

      data = {
        items: items,
        note: cart.note,
        totalPrice: theme.Currency.formatMoney(
          cart.total_price,
          settings.moneyFormat
        ),
      };

      $cartContainer.append(template(data));
      cartCallback(cart);
      if (window.fixCartSampleNames) {
        window.fixCartSampleNames();
      }
    }
  };
  cartCallback = function (cart) {
    setBGNInCart();
    updateSamples(cart);
    $body.removeClass("drawerIsLoading");
    $body.trigger("ajaxCart.afterCartLoad", cart);
  };
  adjustCart = function () {
    $body.on("click", ".qtyAdjust", function () {
      var $el = $(this),
        line = $el.data("line"),
        $qtySelector = $el.siblings(".qtyNum"),
        qty = parseInt($qtySelector.val().replace(/\D/g, ""));
      var qty = validateQty(qty);
      if ($el.hasClass("velaQtyPlus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    $body.on("change", ".qtyNum", function () {
      var $el = $(this),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));
      var qty = validateQty(qty);
      if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on("change", ".drawerQtySelect", function () {
      var $el = $(this),
        line = $el.data("line"),
        qty = this.value;
      var qty = validateQty(qty);
      if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });
    $body.on("focus", ".qtyAdjust", function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });
    $body.on("click", ".cartRemove", function () {
      var $el = $(this),
        line = $el.data("line"),
        qty = 0;
      if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on("click", ".exclusiveServicesHeader", function () {
      $(".exclusiveServices").toggleClass("active");
    });
    // Close variant picker when clicking outside
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".drawerStockings").length) {
        $(".drawerStockings").removeClass("has-selection picker-open");
        $(".drawerSamplesBox").removeClass("selected");
        $(".drawerSamples > .drawerSamplesVariantPicker").hide();
        $(".drawerSamplesVariantOptions").hide();
      }
    });

    // Toggle variant picker dropdown (the select size button)
    $body.on("click", ".drawerSamples > .drawerSamplesVariantPicker .drawerSamplesVariantSelect", function (e) {
      e.stopPropagation();
      const $stockings = $(this).closest(".drawerStockings");
      const $options = $(this).siblings(".drawerSamplesVariantOptions");
      const isOpen = $options.is(":visible");

      if (isOpen) {
        $options.hide();
        $stockings.removeClass("picker-open");
      } else {
        $options.show();
        $stockings.addClass("picker-open");
      }
    });

    // Handle variant option selection
    $body.on("click", ".drawerSamples > .drawerSamplesVariantPicker .drawerSamplesVariantOption", function (e) {
      e.stopPropagation();
      const $option = $(this);
      const $stockings = $option.closest(".drawerStockings");
      const $picker = $option.closest(".drawerSamplesVariantPicker");
      const variantId = $option.data("variant-id");
      const variantTitle = $option.text();

      // Update selected text
      $picker.find(".drawerSamplesVariantSelected").text(variantTitle);

      // Hide dropdown
      $picker.find(".drawerSamplesVariantOptions").hide();
      $stockings.removeClass("picker-open");

      // Add to cart with gift property
      let formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              '_gift_with_purchase': 'true'
            }
          },
        ],
      };
      ShopifyAPI.addItemFromCart(
        formData,
        itemAddedCallbackCart,
        itemErrorCallbackCart
      );

      // Reset selection state after adding
      $stockings.removeClass("has-selection");
      $(".drawerSamplesBox").removeClass("selected");
      $picker.hide();
    });

    // Main click handler for sample box
    $body.on("click", ".drawerSamplesBox", function (e) {
      const $box = $(this);
      const $stockings = $box.closest(".drawerStockings");
      const $picker = $stockings.find("> .drawerSamplesVariantPicker");
      const handle = $box.data("handle");

      // If already added, allow removal
      if ($box.hasClass("sample-added")) {
        const selectedVariant = $box.data("selected-variant");
        let line = 0;

        $(".ajaxCartInner .drawerProduct").each(function (index, drawerProduct) {
          var id = $(drawerProduct).data("id");
          if (id == selectedVariant) {
            line = $(drawerProduct).data("line");
          }
        });

        if (line > 0) {
          updateQuantity(line, 0);
        }
        return;
      }

      // Check if max samples reached
      if ($stockings.find(".drawerSamplesGrid").hasClass("max-samples-added")) {
        return;
      }

      // If clicking same selected box, deselect
      if ($box.hasClass("selected")) {
        $box.removeClass("selected");
        $stockings.removeClass("has-selection picker-open");
        $picker.hide();
        $picker.find(".drawerSamplesVariantOptions").hide();
        return;
      }

      // Select this box
      $(".drawerSamplesBox").removeClass("selected");
      $box.addClass("selected loading");
      $stockings.addClass("has-selection");

      // Fetch product data to get variants
      fetch('/products/' + handle + '.js')
        .then(response => response.json())
        .then(product => {
          $box.removeClass("loading");

          // Filter available variants
          const availableVariants = product.variants.filter(v => v.available);

          if (availableVariants.length > 1) {
            // Populate and show variant picker below grid
            const $optionsList = $picker.find(".drawerSamplesVariantOptions");
            $optionsList.empty();
            availableVariants.forEach(function(variant) {
              $optionsList.append(
                '<li class="drawerSamplesVariantOption" data-variant-id="' + variant.id + '">' +
                variant.title +
                '</li>'
              );
            });

            // Reset picker text and show
            $picker.find(".drawerSamplesVariantSelected").text("Select size");
            $picker.show();
            $picker.find(".drawerSamplesVariantOptions").hide();
            $stockings.removeClass("picker-open");
          } else if (availableVariants.length === 1) {
            // Single variant - add directly with gift property
            let formData = {
              items: [
                {
                  id: availableVariants[0].id,
                  quantity: 1,
                  properties: {
                    '_gift_with_purchase': 'true'
                  }
                },
              ],
            };
            ShopifyAPI.addItemFromCart(
              formData,
              itemAddedCallbackCart,
              itemErrorCallbackCart
            );
            // Reset selection
            $stockings.removeClass("has-selection");
            $box.removeClass("selected");
            $picker.hide();
          }
        })
        .catch(err => {
          $box.removeClass("loading selected");
          $stockings.removeClass("has-selection");
          console.error('Error fetching product:', err);
        });
    });
    const drawerProductTitlesSelector = ".drawerProductTitle a";
    $body.on("ajaxCart.afterCartLoad", function () {
      wait_for_elem(drawerProductTitlesSelector).then((drawer_sample_name) => {
        let drawerProductTitles = document.querySelectorAll(drawerProductTitlesSelector);
      
        drawerProductTitles.forEach(function (title) {
          let originalTitle = title.getAttribute('data-title');
          let titleCaseTitle = toTitleCase(originalTitle).replace("By Far", "BY FAR");
      
          title.textContent = titleCaseTitle;
        });     
      });
    });
    $body.on("ajaxCart.afterCartLoad", function () {
      $(".drawerSamplesGrid").owlCarousel({
        items: 3,
        autoHeight: true,
        nav: true,
        dots: false,
        touchDrag: true,
      });
    });
    function updateQuantity(line, qty) {
      isUpdating = true;
      var $row = $('.ajaxCartRow[data-line="' + line + '"]').addClass(
        "is-loading"
      );
      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }
    $body.on("change", 'textarea[name="note"]', function () {
      var newNote = $(this).val();
      ShopifyAPI.updateCartNote(newNote, function (cart) {});
    });
  };
  adjustCartCallback = function (cart) {
    isUpdating = false;
    updateCountPrice(cart);
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
    }, 150);
  };
  createQtySelectors = function () {
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();
        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;
        var source = $("#velaAjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
          };
        $el.after(template(data)).remove();
      });
    }
  };
  qtySelectors = function () {
    var numInputs = $('input[type="number"]');
    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id");
        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;
        var source = $("#velaJsQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
          };
        $el.after(template(data)).remove();
      });
      $("body").on("click", ".velaQtyAdjust", function () {
        var $el = $(this),
          id = $el.data("id"),
          $qtySelector = $el.siblings(".velaQtyNum"),
          qty = parseInt($qtySelector.val().replace(/\D/g, ""));
        var qty = validateQty(qty);
        if ($el.hasClass("velaQtyPlus")) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
        $qtySelector.val(qty);
      });
    }
  };
  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    } else {
      qty = 1;
    }
    return qty;
  };
  module = {
    init: init,
    load: loadCart,
  };
  return module;
})(ajaxCart || {}, jQuery);
$(document).ready(function () {
  ajaxCart.init({
    formSelector: ".formAddToCart",
    cartContainer: "#cartContainer",
    addToCartSelector: ".btnAddToCart",
    cartCountSelector: "#CartCount",
    drawerCartCountSelector: "#drawerCartCount",
    cartCostSelector: "#CartCost",
    moneyFormat: window.money,
  });
});

window.___ajaxCart = ajaxCart;
